module.exports = __webpack_public_path__ + "static/img/buyer_logo_23.e74f71d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buyer/buyer_logo_23.jpg
// module id = koZ8
// module chunks = 0